import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AuditoriaFiltros,
  ListarAuditoriaResponse,
  ListarOticSapResponse,
  OticSapFiltros
} from '../../interface/auditoria/auditoria-sap.interface';

@Injectable({
  providedIn: 'root'
})
export class AuditoriaSapService {

  constructor(private readonly http: HttpClient) { }

  listarAuditoriaSap(
    filtros: AuditoriaFiltros
  ): Observable<ListarAuditoriaResponse> {
    let params = new HttpParams()
      .set('limit', filtros.limit)
      .set('offset', filtros.offset);

    if (filtros.procId !== null && filtros.procId !== undefined) {
      params = params.set('procId', filtros.procId);
    }

    if (filtros.centProcId !== null && filtros.centProcId !== undefined) {
      params = params.set('centProcId', filtros.centProcId);
    }

    if (filtros.procNombre?.trim()) {
      params = params.set('procNombre', filtros.procNombre.trim());
    }

    if (filtros.centProcNombre?.trim()) {
      params = params.set(
        'centProcNombre',
        filtros.centProcNombre.trim()
      );
    }

    if (filtros.fechaDesde) {
      params = params.set('fechaDesde', filtros.fechaDesde);
    }

    if (filtros.fechaHasta) {
      params = params.set('fechaHasta', filtros.fechaHasta);
    }

    return this.http.get<ListarAuditoriaResponse>(`${environment.API_DOMAINS.OTIC_CR}/auditoria/listarAuditoriaSap`, {
      params
    });
  }

  listarOticSap(
    filtros: OticSapFiltros
  ): Observable<ListarOticSapResponse> {
    let params = new HttpParams()
      .set('limit', filtros.limit)
      .set('offset', filtros.offset);


    if (filtros.fechaDesde) {
      params = params.set('fechaDesde', filtros.fechaDesde);
    }

    if (filtros.fechaHasta) {
      params = params.set('fechaHasta', filtros.fechaHasta);
    }

    return this.http.get<ListarOticSapResponse>(`${environment.API_DOMAINS.OTIC_CR}/auditoria/listarOticSap`, {
      params
    });
  }
}
